import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const faqs = [
    {
        q: "I only want two reels made — can you do that?",
        a: "I love the work, but I avoid small one-off jobs — they eat time without delivering strong results. I prefer full packages because consistent effort compounds into real conversions.",
    },
    {
        q: "How does scheduling work for shoots?",
        a: "Once payment is complete I share my private calendar. You book slots that fit your week — no back-and-forth, no messy WhatsApp threads.",
    },
    {
        q: "Is payment upfront, or can I pay in installments?",
        a: "Upfront payments keep the process smooth and prove commitment on both sides. Partial payments have historically caused delays and confusion — so I stick to full-upfront.",
    },
    {
        q: "How long does it take to receive final videos after a shoot?",
        a: "Standard reel editing turnaround is 48 hours, with room for up to 2 rounds of revisions if needed.",
    },
    {
        q: "How do I know I'm working with the right person?",
        a: "My clients' results speak louder than I ever could. Ask and I'll connect you with satisfied clients directly — and check the Highlights on my Instagram (@growwithbabur) for reviews.",
    },
    {
        q: "What support do I get after the package ends?",
        a: "I build long-term relationships, not one-off deals. I measure success by your growth and offer ongoing feedback even after our contract ends.",
    },
    {
        q: "Are ad spend, domain and hosting included?",
        a: "No — advertising / boost budget, domain purchases and hosting are separate from the package price. I'll advise on smart minimums for your niche during our call.",
    },
];

export default function FAQ() {
    return (
        <section id="faq" className="relative py-24 sm:py-32 border-t border-white/10">
            <div className="max-w-6xl mx-auto px-5 sm:px-8">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
                    <div className="md:col-span-4">
                        <div className="eyebrow mb-4 flex items-center gap-3">
                            <span className="inline-block w-10 h-[2px] bg-brand" /> Questions
                        </div>
                        <h2 className="font-display font-medium tracking-[-0.04em] text-4xl sm:text-5xl text-white leading-[1.02]">
                            Ask.<br />
                            <span className="text-brand">Answered.</span>
                        </h2>
                        <p className="mt-6 text-white/60 text-sm leading-relaxed">
                            Everything you'd want to know before we start.
                            Still curious?{" "}
                            <a href="#contact" className="text-brand hover:underline">Drop a note &darr;</a>
                        </p>
                    </div>

                    <div className="md:col-span-8">
                        <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
                            {faqs.map((f, i) => (
                                <AccordionItem key={i} value={`item-${i}`} className="border-white/10">
                                    <AccordionTrigger className="text-left text-white hover:text-brand hover:no-underline font-display font-medium text-lg sm:text-xl py-6 tracking-[-0.02em]" data-testid={`faq-trigger-${i}`}>
                                        <span className="flex items-center gap-4">
                                            <span className="font-mono text-xs text-brand shrink-0">0{i + 1}</span>
                                            {f.q}
                                        </span>
                                    </AccordionTrigger>
                                    <AccordionContent className="text-white/70 leading-relaxed text-base pl-10 pb-6">
                                        {f.a}
                                    </AccordionContent>
                                </AccordionItem>
                            ))}
                        </Accordion>
                    </div>
                </div>
            </div>
        </section>
    );
}
